import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login/Login.vue';
import Store from './store/store';
import Dashboard from './views/Dashboard/Dashboard.vue';
import Group from './views/Group/Group.vue';


Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: '/',
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login,
            meta: {
                public: true,  // Allow access to even if not logged in
                onlyWhenLoggedOut: true
            }
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard,
        },
        {
            path: '/group/:name/:groupID',
            name: 'group',
            component: Group,
            props: true,
            meta: {
                onlyWhenLoggedOut: false
            }
        },
        {
            path: '/logout',
            name: 'logout',
            meta: {
                logout: true
            }
        },


    ]
});


router.beforeEach((to, from, next) => {
    const isPublic = to.matched.some(record => record.meta.public);
    const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut);
    const LoggedOut = to.matched.some(record => record.meta.logout);
    const loggedIn = Store.getters.IS_AUTHENTICATED;

    if (LoggedOut) {

        sessionStorage.clear();
        return window.location.href = '/login';

    }

    if (!isPublic && !loggedIn) {
        return next({
            name: 'login',
        });
    }

    // Do not allow user to visit login page or register page if they are logged in
    if (loggedIn && onlyWhenLoggedOut) {
        return next({name: 'dashboard'});
    }

    next();
});

export default router;
